(function(){
  document.addEventListener('change',function(e){
    var el=e.target;
    if(!el.matches||!el.matches('[data-owca-autosubmit]'))return;
    var f=el.form;if(!f)return;
    if(f.requestSubmit){f.requestSubmit()}else{f.submit()}
  });
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches||!f.matches('[data-owca-filters]'))return;
    Array.prototype.forEach.call(f.querySelectorAll('input[type=number]'),function(i){if(i.value==='')i.disabled=true});
  });
  document.addEventListener('toggle',function(e){
    var d=e.target;
    if(!d.classList||!d.classList.contains('owca-flt')||!d.open)return;
    document.querySelectorAll('.owca-flt[open]').forEach(function(o){if(o!==d)o.open=false});
  },true);
  document.addEventListener('click',function(e){
    if(e.target.closest('.owca-size')){setTimeout(syncSold,0)}
    if(e.target.closest('.owca-flt'))return;
    document.querySelectorAll('.owca-flt[open]').forEach(function(o){o.open=false});
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    document.querySelectorAll('.owca-flt[open]').forEach(function(o){o.open=false;var s=o.querySelector('summary');if(s)s.focus()});
  });
  function syncSold(){
    document.querySelectorAll('[data-owca-pdp]').forEach(function(root){
      var note=root.querySelector('[data-owca-soldout]');var btn=root.querySelector('[data-owca-add]');
      if(!note||!btn)return;
      var allSold=root.querySelector('.owca-gallery__main.is-sold')!==null;
      if(allSold){btn.disabled=true;btn.textContent=btn.getAttribute('data-label-sold');note.hidden=false;return}
      note.hidden=!(btn.disabled&&btn.textContent.trim()===btn.getAttribute('data-label-sold'));
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(syncSold,0)})}else{setTimeout(syncSold,0)}
})();